<template>
  <BsModal ref="interiorCheckModalRef" class="fade">
    <!-- header -->
    <template v-slot:header></template>
    <!-- ./header -->
    <!-- body -->
    <div class="border p-1">
      <div>
        <label for="A" class="text-nowrap me-2">
          <input
            type="radio"
            id="A"
            name="interior-radio"
            value="A"
          />【A】キズ</label
        >
        <label for="K" class="text-nowrap me-2">
          <input
            type="radio"
            id="K"
            name="interior-radio"
            value="K"
          />【K】コゲ</label
        >
        <label for="S" class="text-nowrap me-2">
          <input
            type="radio"
            id="S"
            name="interior-radio"
            value="S"
          />【S】スレ</label
        >
        <label for="SI" class="text-nowrap me-2">
          <input
            type="radio"
            id="SI"
            name="interior-radio"
            value="SI"
          />【SI】シミ</label
        >
        <label for="W" class="text-nowrap me-2">
          <input
            type="radio"
            id="W"
            name="interior-radio"
            value="W"
          />【W】割れ</label
        >
        <label for="N" class="text-nowrap me-2">
          <input
            type="radio"
            id="N"
            name="interior-radio"
            value=""
          />【N】無し</label
        >
      </div>
      <div
        class="w-100"
        style="
          background-image: url(/images/check_02.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
        "
      >
        <div
          class="row d-flex flex-nowrap px-3"
          v-for="m in interiorCheckRow"
          :key="m"
        >
          <div
            v-for="n in interiorCheckCol"
            :key="n"
            :id="'interior_modal_' + m + '_' + n"
            class="col d-flex align-items-center justify-content-center interior_cell border"
            style="height: 90px; font-size: 150%"
            :data-row="m"
            :data-col="n"
            @mousedown.prevent="setInteriorCheck(m, n)"
            @touchstart.prevent="setInteriorCheck(m, n)"
          ></div>
        </div>
      </div>
    </div>
    <!-- ./body -->

    <!-- footer -->
    <template v-slot:footer>
      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
        閉じる
      </button>
      <button
        type="button"
        class="btn btn-primary"
        @mousedown.prevent="setInteriorData()"
        @touchstart.prevent="setInteriorData()"
      >
        保存
      </button>
    </template>
    <!-- ./footer -->
  </BsModal>
</template>

<script lang="ts">
/* Import Modules */
import { defineComponent } from "vue";
import { BsModal } from "bs-modal-vue";
/* Import Components */
/* Import Variables */
import {
  showInteriorCheckModal,
  interiorCheckModalRef,
  setInteriorCheck,
  setInteriorData,
  interiorCheckRow,
  interiorCheckCol,
} from "../../../compositions/rentContract/carScratches/interior";
/* Import Script */
export default defineComponent({
  components: {
    BsModal,
  },
  setup() {
    return {
      showInteriorCheckModal,
      interiorCheckModalRef,
      setInteriorCheck,
      setInteriorData,
      interiorCheckRow,
      interiorCheckCol,
    };
  },
});
</script>
